import {Winner} from "./winner";
import {HttpClient} from "@angular/common/http";
import {UrlsResources} from "../../../core/urls-resources";
import {MegamillionsRules} from "../../businessRules/megamillions-rules/megamillions-rules";
import {Injectable} from "@angular/core";
import {Games} from "./games";

@Injectable()
export class EAccountService {
  constructor(
    private http: HttpClient,
    private urlsResources: UrlsResources,
  ) {
  }

  addWinner(winner: Winner) {
    let headers = {
      withCredentials: true
    };
    return this.http.post<MegamillionsRules>(this.urlsResources.addWinnerUrl(), winner, headers);
  }

  getAvailableGames() {
    let headers = {
      withCredentials: true
    };
    return this.http.get<Games[]>(this.urlsResources.availabelGamesUrl(), headers);
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/components/payments/electronic-account/e-account.service.ts